import _classCallCheck from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Combobox = /*#__PURE__*/function () {
  function Combobox(input, list) {
    var _this = this;

    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        tabInsertsSuggestions = _ref.tabInsertsSuggestions,
        defaultFirstOption = _ref.defaultFirstOption;

    _classCallCheck(this, Combobox);

    this.input = input;
    this.list = list;
    this.tabInsertsSuggestions = tabInsertsSuggestions !== null && tabInsertsSuggestions !== void 0 ? tabInsertsSuggestions : true;
    this.defaultFirstOption = defaultFirstOption !== null && defaultFirstOption !== void 0 ? defaultFirstOption : false;
    this.isComposing = false;

    if (!list.id) {
      list.id = "combobox-".concat(Math.random().toString().slice(2, 6));
    }

    this.ctrlBindings = !!navigator.userAgent.match(/Macintosh/);

    this.keyboardEventHandler = function (event) {
      return keyboardBindings(event, _this);
    };

    this.compositionEventHandler = function (event) {
      return trackComposition(event, _this);
    };

    this.inputHandler = this.clearSelection.bind(this);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-controls', list.id);
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
  }

  _createClass(Combobox, [{
    key: "destroy",
    value: function destroy() {
      this.clearSelection();
      this.stop();
      this.input.removeAttribute('role');
      this.input.removeAttribute('aria-controls');
      this.input.removeAttribute('aria-expanded');
      this.input.removeAttribute('aria-autocomplete');
      this.input.removeAttribute('aria-haspopup');
    }
  }, {
    key: "start",
    value: function start() {
      this.input.setAttribute('aria-expanded', 'true');
      this.input.addEventListener('compositionstart', this.compositionEventHandler);
      this.input.addEventListener('compositionend', this.compositionEventHandler);
      this.input.addEventListener('input', this.inputHandler);
      this.input.addEventListener('keydown', this.keyboardEventHandler);
      this.list.addEventListener('click', commitWithElement);
      this.indicateDefaultOption();
    }
  }, {
    key: "stop",
    value: function stop() {
      this.clearSelection();
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeEventListener('compositionstart', this.compositionEventHandler);
      this.input.removeEventListener('compositionend', this.compositionEventHandler);
      this.input.removeEventListener('input', this.inputHandler);
      this.input.removeEventListener('keydown', this.keyboardEventHandler);
      this.list.removeEventListener('click', commitWithElement);
    }
  }, {
    key: "indicateDefaultOption",
    value: function indicateDefaultOption() {
      var _a;

      if (this.defaultFirstOption) {
        (_a = Array.from(this.list.querySelectorAll('[role="option"]:not([aria-disabled="true"])')).filter(visible)[0]) === null || _a === void 0 ? void 0 : _a.setAttribute('data-combobox-option-default', 'true');
      }
    }
  }, {
    key: "navigate",
    value: function navigate() {
      var indexDiff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var focusEl = Array.from(this.list.querySelectorAll('[aria-selected="true"]')).filter(visible)[0];
      var els = Array.from(this.list.querySelectorAll('[role="option"]')).filter(visible);
      var focusIndex = els.indexOf(focusEl);

      if (focusIndex === els.length - 1 && indexDiff === 1 || focusIndex === 0 && indexDiff === -1) {
        this.clearSelection();
        this.input.focus();
        return;
      }

      var indexOfItem = indexDiff === 1 ? 0 : els.length - 1;

      if (focusEl && focusIndex >= 0) {
        var newIndex = focusIndex + indexDiff;
        if (newIndex >= 0 && newIndex < els.length) indexOfItem = newIndex;
      }

      var target = els[indexOfItem];
      if (!target) return;

      var _iterator = _createForOfIteratorHelper(els),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;
          el.removeAttribute('data-combobox-option-default');

          if (target === el) {
            this.input.setAttribute('aria-activedescendant', target.id);
            target.setAttribute('aria-selected', 'true');
            scrollTo(this.list, target);
          } else {
            el.removeAttribute('aria-selected');
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.input.removeAttribute('aria-activedescendant');

      var _iterator2 = _createForOfIteratorHelper(this.list.querySelectorAll('[aria-selected="true"]')),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var el = _step2.value;
          el.removeAttribute('aria-selected');
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.indicateDefaultOption();
    }
  }]);

  return Combobox;
}();

export { Combobox as default };

function keyboardBindings(event, combobox) {
  if (event.shiftKey || event.metaKey || event.altKey) return;
  if (!combobox.ctrlBindings && event.ctrlKey) return;
  if (combobox.isComposing) return;

  switch (event.key) {
    case 'Enter':
      if (commit(combobox.input, combobox.list)) {
        event.preventDefault();
      }

      break;

    case 'Tab':
      if (combobox.tabInsertsSuggestions && commit(combobox.input, combobox.list)) {
        event.preventDefault();
      }

      break;

    case 'Escape':
      combobox.clearSelection();
      break;

    case 'ArrowDown':
      combobox.navigate(1);
      event.preventDefault();
      break;

    case 'ArrowUp':
      combobox.navigate(-1);
      event.preventDefault();
      break;

    case 'n':
      if (combobox.ctrlBindings && event.ctrlKey) {
        combobox.navigate(1);
        event.preventDefault();
      }

      break;

    case 'p':
      if (combobox.ctrlBindings && event.ctrlKey) {
        combobox.navigate(-1);
        event.preventDefault();
      }

      break;

    default:
      if (event.ctrlKey) break;
      combobox.clearSelection();
  }
}

function commitWithElement(event) {
  if (!(event.target instanceof Element)) return;
  var target = event.target.closest('[role="option"]');
  if (!target) return;
  if (target.getAttribute('aria-disabled') === 'true') return;
  fireCommitEvent(target);
}

function commit(input, list) {
  var target = list.querySelector('[aria-selected="true"], [data-combobox-option-default="true"]');
  if (!target) return false;
  if (target.getAttribute('aria-disabled') === 'true') return true;
  target.click();
  return true;
}

function fireCommitEvent(target) {
  target.dispatchEvent(new CustomEvent('combobox-commit', {
    bubbles: true
  }));
}

function visible(el) {
  return !el.hidden && !(el instanceof HTMLInputElement && el.type === 'hidden') && (el.offsetWidth > 0 || el.offsetHeight > 0);
}

function trackComposition(event, combobox) {
  combobox.isComposing = event.type === 'compositionstart';
  var list = document.getElementById(combobox.input.getAttribute('aria-controls') || '');
  if (!list) return;
  combobox.clearSelection();
}

function scrollTo(container, target) {
  if (!inViewport(container, target)) {
    container.scrollTop = target.offsetTop;
  }
}

function inViewport(container, element) {
  var scrollTop = container.scrollTop;
  var containerBottom = scrollTop + container.clientHeight;
  var top = element.offsetTop;
  var bottom = top + element.clientHeight;
  return top >= scrollTop && bottom <= containerBottom;
}